import {Flex, Text} from "../../../../components";
import React from "react";
import styled from "styled-components";
import moment from '../../../../utils/MomentConst';

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg};
`;

const Container = styled(Flex)`
  width: 100%;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
  background: #161930;
  border-radius: 5px;
  padding: 12px 18px;
  margin-bottom: 12px;
`;

const TruncateText = styled(Text.Body)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;


const WaitingUser = ({data, editWaitingUser}) => {

  return (
    <Container align='center' minw="840px">
      <Flex w="15%">
        <TruncateText>{data.discord_id}</TruncateText>
      </Flex>
      <Flex w="15%">
        <TruncateText>{data.email}</TruncateText>
      </Flex>
      <Flex w="15%">
        <TruncateText>{data.sent ? "Yes" : "No"}</TruncateText>
      </Flex>
      <Flex w="15%">
        <TruncateText>{data.sent_count}</TruncateText>
      </Flex>
      <Flex w="15%">
        <TruncateText>{moment(data.createdAt).format('MMMM D, YYYY, HH:MM:SS')}</TruncateText>
      </Flex>
      <Flex fg="1" />
      <Button bg="#0393FF" onClick={() => editWaitingUser(data)}>Edit</Button>
    </Container>
  )
}

export default WaitingUser;
